import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  allSliders: [],
  allSlidersLoading: false,
  homeTrackProfile: {},
  homeTrackProfileLoading: false,
  homeGettingStarted: [{}],
  homeGettingStartedLoading: false,
  homeDetailInfo: [{}],
  homeDetailInfoLoading: false,
  homeSectionInfo: [{}],
  homeSectionInfoLoading: false,
  necs: [{}],
  necsLoading: false
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
